module.exports = __webpack_public_path__ + "img/role5.f12a1456.png";